<template>
  <div>
    <a-card :bordered="false" hoverable :bodyStyle="bodyStyle" style="margin: 0px 30px 20px 30px">
      <a-row>
        <a-col :span="1">
          <img src="@/assets/uploadIcon/pdf.svg" alt="" style="width: 30px; height: 36px" />
        </a-col>
        <a-col :span="20" @click="review(data)">
          <div>
            <a-row>
              <a-col :span="24">
                <div
                  style="
                    margin-top: 4px;
                    font-weight: 700;
                    display: inline;
                    font-size: 18px;
                    font-weight: 800;
                    color: #333333;
                    line-height: 14px;
                  "
                >
                  {{ data.title }}
                </div>
              </a-col>
            </a-row>
            <a-row style="margin-top: 9px">
              <div style="font-size: 14px; font-weight: 500; color: #999999; line-height: 14px">
                {{ data.parseFailedWebDocResultDto.desc }}
              </div>
            </a-row>
            <a-row style="margin-top: 29px">
              <div
                style="
                  font-size: 12px;

                  font-weight: 400;
                  color: #999999;
                  line-height: 14px;
                  display: inline;
                "
              >
                来源：{{ data.parseFailedWebDocResultDto.source }}
              </div>
              <a-divider type="vertical" id="dividerFormat" />
              <div
                style="
                  font-size: 12px;

                  font-weight: 400;
                  color: #999999;
                  line-height: 14px;
                  display: inline;
                "
              >
                国家：{{ data.parseFailedWebDocResultDto.countryName }}
              </div>
              <a-divider type="vertical" id="dividerFormat" />
              <div
                style="
                  font-size: 12px;

                  font-weight: 400;
                  color: #999999;
                  line-height: 14px;
                  display: inline;
                "
              >
                语言：{{ data.parseFailedWebDocResultDto.langName }}
              </div>
              <a-divider type="vertical" id="dividerFormat" />
              <div
                style="
                  font-size: 12px;

                  font-weight: 400;
                  color: #999999;
                  line-height: 14px;
                  display: inline;
                "
              >
                发布时间：{{ data.parseFailedWebDocResultDto.publishTime }}
              </div>
            </a-row>
          </div>
        </a-col>
      </a-row>

      <a-button
        :style="{
          marginRight: '30px',
          width: '120px',
          height: '40px',
          background: '#3C93FF',
          borderRadius: '6px !important',
          position: 'absolute',
          right: '70px',
          bottom: '71px',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#FFFFFF'
        }"
        @click="download(data)"
      >
        下载
      </a-button>
    </a-card>
    <pdfViewer ref="pdfViewer"></pdfViewer>
  </div>
</template>

<script>
// import { pictureFind } from '@/api/productCenter/index.js'

import moment from 'moment'
import pdfViewer from './pdfViewer'
import axios from 'axios'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['data', 'tabState'],
  data() {
    return {
      stateName: this.tabState,
      type: '',
      typeName: '',
      case: 'style1',
      isA: true,
      isB: false,
      isC: false,
      isD: false,
      bodyStyle: {
        padding: '30px 30px 30px 49px'
      }
    }
  },
  created() {
    // this.List = this.$store.state.localLX
  },
  components: { pdfViewer },
  computed: {},
  mounted() {
    // this.dema()
  },
  beforeDestroy() {},
  methods: {
    review(data) {
      this.$refs.pdfViewer.openModel(data)
    },
    download(data) {
      let fileurl = data.parseFailedWebDocResultDto.urlHdfsPath
      axios({
        methods: 'get',
        url: fileurl,
        responseType: 'arraybuffer'
      }).then((res) => {
        const blob = new Blob([res.data])
        const downloadHref = URL.createObjectURL(blob)
        let downloadLink = document.createElement('a')
        downloadLink.href = downloadHref
        downloadLink.download = `${data.parseFailedWebDocResultDto.title}.pdf`
        downloadLink.click()
      })
    },

    compareSrc(param) {
      if (param === null) {
        if (this.data.typeMetaId === 53) {
          return this.defaultSrcMl
        }
        return this.defaultSrc
      } else {
        return `/pmc/hdfs/show/app_icon/${this.data.id}`
      }
    },
    resetDATE(record) {
      const a = moment(record).format('YYYY-MM-DD HH:mm:ss')
      const b = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      if (moment(b).diff(moment(a), 'minutes') <= 0) {
        return '刚刚更新'
      }
      if (moment(b).diff(moment(a), 'minutes') <= 60) {
        return moment(b).diff(moment(a), 'minutes') + '分钟前更新'
      }
      if (
        moment(b).diff(moment(a), 'minutes') > 60 &&
        moment(b).diff(moment(a), 'minutes') < 60 * 24
      ) {
        return moment(b).diff(moment(a), 'hours') + '小时前更新'
      }
      if (moment(b).diff(moment(a), 'days') < 30) {
        return moment(b).diff(moment(a), 'days') + '天前更新'
      } else {
        return moment(b).diff(moment(a), 'months') + '月前更新'
      }
    },
    pictureReturn(id) {
      pictureFind(id).then((res) => {
        return res
      })
    },
    changePage() {
      // this.$router.push({ path: '/productCenter/productOverview' })
      this.$store.commit('saveLocalData', this.data)
      this.$router.push({ path: `/productMangement/productOverview/overview/${this.data.id}` })
    },
    dema(data) {
      switch (data) {
        case 7:
          return '#9DAAC9'
        case 8:
          return '#DEC898'
        case 9:
          return '#99C1D3'
        case 10:
          return '#B9A5D5'
        case 11:
          return '#98C08E'
        default:
          break
      }
    },
    checkColor() {
      // const color = this.dema(data)
      const a = {
        width: '116px',
        height: '30px',
        background: this.data.typeMetaColor,
        'border-radius': '2px',
        position: 'absolute',
        right: '-30px',
        top: '-30px'
      }
      return a
    },
    checkList(data) {
      let returname = ''
      this.List.forEach((element) => {
        if (data === element.id) {
          returname = element.metaValue
        }
      })
      return returname
    }
  }
}
</script>

<style scoped>
#dividerFormat /deep/ .ant-divider,
.ant-divider-vertical {
  margin: 0 20px;
}
</style>
